module.exports = __webpack_public_path__ + "fonts/KaTeX_AMS-Regular.56573229.ttf";